<template>
  <v-popover
    :offset="offset"
    :placement="placement"
    :trigger="trigger"
    :delay="delay"
    class="popover-component"
    :class="'popover-component--' + theme"
  >
    <slot name="trigger">
      <FontAwesomeIcon class="popover-component-icon" :icon="icon" />
    </slot>
    <template #popover>
      <slot name="default" />
    </template>
  </v-popover>
</template>

<script>
const IconMap = {
  question: 'question-circle',
  default: 'question-circle',
  info: 'info-circle',
  warning: 'exclamation-triangle',
  error: 'exclamation-circle',
  success: 'check-circle',
}

export default {
  props: {
    trigger: {
      type: String,
      enum: ['hover', 'focus', 'click', 'manual'],
      default: 'hover',
    },
    theme: {
      type: String,
      enum: ['default', 'question', 'info', 'warning', 'error', 'success'],
      default: 'default',
    },
    placement: {
      type: String,
      enum: ['top', 'bottom', 'left', 'right'],
      default: 'top',
    },
    offset: {
      type: String,
      default: '0',
    },
    delay: [String, Number],
  },
  computed: {
    icon() {
      return ['fas', IconMap[this.theme]]
    },
  },
}
</script>

<style lang="scss">
.popover-component {
  --icon-size: 0.9rem;
  --icon-space: 0.2rem;

  display: inline-block;

  .trigger {
    display: inline-flex !important;
    justify-content: center;
    align-items: center;
    height: calc(var(--icon-size) + var(--icon-space));
    width: calc(var(--icon-size) + var(--icon-space));
    border-radius: 50%;
    border: calc(var(--icon-space) / 2) solid $grey;
  }
  &-icon {
    cursor: help;
    width: var(--icon-size) !important;
    height: var(--icon-size);

    &:hover {
      opacity: 1;
    }
  }

  $states: (
    default: 'dark',
    question: 'dark',
    info: 'primary',
    warning: 'warning',
    success: 'success',
    error: 'error',
  );

  @each $name, $key in $states {
    &--#{$name} {
      .trigger {
        color: var(--#{$key});
      }
    }
  }
}
</style>
